"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dismissSystemMessage = exports.sendSystemMessage = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEND_SYSTEM_MESSAGE = "SEND_SYSTEM_MESSAGE",
    DISMISS_SYSTEM_MESSAGE = "DISMISS_SYSTEM_MESSAGE";
var UNIQUE_ID = 0;

var getUniqueId = function getUniqueId() {
  return "system-message-".concat(++UNIQUE_ID);
};

var MESSAGE_TYPES = ["Danger", "Warning", "Success", "Info"];
var DEFAULT_MESSAGE_OPTIONS = {
  duration: 7500,
  type: MESSAGE_TYPES[0],
  onDismiss: function onDismiss() {},
  onConfirm: null
};

var getMessageOptions = function getMessageOptions(options) {
  if (!options.id) {
    options.id = getUniqueId();
  }

  if (!MESSAGE_TYPES.includes(options.type)) {
    options.type = MESSAGE_TYPES[0];
  }

  return options;
};

var sendSystemMessage = function sendSystemMessage(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: SEND_SYSTEM_MESSAGE,
      message: message,
      options: getMessageOptions(_objectSpread(_objectSpread({}, DEFAULT_MESSAGE_OPTIONS), options))
    }));
  };
};

exports.sendSystemMessage = sendSystemMessage;

var dismissSystemMessage = function dismissSystemMessage(id) {
  return function (dispatch) {
    return Promise.resolve(dispatch({
      type: DISMISS_SYSTEM_MESSAGE,
      id: id
    }));
  };
};

exports.dismissSystemMessage = dismissSystemMessage;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SEND_SYSTEM_MESSAGE:
      {
        var newState = state.filter(function (_ref) {
          var id = _ref.id;
          return id !== action.options.id;
        });
        newState.push(_objectSpread({
          message: action.message
        }, action.options));
        return newState;
      }

    case DISMISS_SYSTEM_MESSAGE:
      {
        return state.filter(function (_ref2) {
          var id = _ref2.id;
          return id !== action.id;
        });
      }

    default:
      return state;
  }
};

exports["default"] = _default;